import { z } from 'zod';
import { ApiUserRole, type OperatorTaskRelatedResponse } from '@/core/generated/api';

/** Проверяет полноту связи задачи с нативным или внешним диалогом */
export const isTaskChatRelated = (related: OperatorTaskRelatedResponse): boolean => {
    if (!related.chatId) return false;

    if (!related.companionAppUserId && !related.companionRole) {
        return z.guid().safeParse(related.chatId).success;
    }

    return Boolean(related.companionAppUserId)
        && (related.companionRole?.id === ApiUserRole.Client
            || related.companionRole?.id === ApiUserRole.Executor);
};
